import { Link } from 'react-router-dom';
import { ChevronRight, Home } from 'lucide-react';

export interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbsProps {
  items: BreadcrumbItem[];
}

export function Breadcrumbs({ items }: BreadcrumbsProps) {
  return (
    <nav aria-label="Breadcrumb" className="mb-4">
      <ol className="flex items-center flex-wrap gap-1 text-sm">
        {items.map((item, index) => (
          <li key={index} className="flex items-center min-w-0">
            {index > 0 && (
              <ChevronRight className="h-4 w-4 mx-1 text-muted-foreground flex-shrink-0" />
            )}
            {item.href ? (
              <Link
                to={item.href}
                className="flex items-center gap-1 text-muted-foreground hover:text-foreground transition-colors min-w-0"
              >
                {index === 0 && <Home className="h-4 w-4 flex-shrink-0" />}
                <span className="hidden sm:inline truncate">{item.label}</span>
                {index === 0 && <span className="sm:hidden truncate">{item.label}</span>}
              </Link>
            ) : (
              <span className="text-foreground font-medium truncate max-w-[200px]">
                {item.label}
              </span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}
